import httpService from "./httpService";
import utils from "./utils";

export default {

  count(usingAdvanceSearch, keyword, status, form, docStatus, fromCreateTime, toCreateTime, fromDocDate, toDocDate) {
    let params = utils.merge(
      {
        usingAdvanceSearch: usingAdvanceSearch,
        keyword: keyword,
        status: status,
        docStatus: docStatus,
        fromCreateTime: fromCreateTime,
        toCreateTime: toCreateTime,
        fromDocDate: fromDocDate,
        toDocDate: toDocDate
      },
      form
    );

    return httpService.get("/vbOutgoingDocUserView/count", {params: params});
  },

  findAll(usingAdvanceSearch, keyword, status, form, pageable, docStatus,
          fromCreateTime, toCreateTime, fromDocDate, toDocDate,
          fromProcessTime, toProcessTime, fromVbDocUserUpdateTime, toVbDocUserUpdateTime, relationType) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      utils.merge(
        {
          usingAdvanceSearch: usingAdvanceSearch,
          keyword: keyword,
          status: status,
          docStatus: docStatus,
          fromCreateTime: fromCreateTime,
          toCreateTime: toCreateTime,
          fromDocDate: fromDocDate,
          toDocDate: toDocDate,
          fromProcessTime: fromProcessTime,
          toProcessTime: toProcessTime,
          fromVbDocUserUpdateTime: fromVbDocUserUpdateTime,
          toVbDocUserUpdateTime: toVbDocUserUpdateTime,
          relationType: relationType
        },
        form
      ),
      pageable
    );

    return httpService.get("/vbOutgoingDocUserView", {params: params});
  },

  findAll2(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/vbOutgoingDocUserView", {params: params});
  },

  findByDocId(docId, params) {
    return httpService.get("/vbOutgoingDocUserView/findByDocId/" + docId, params);
  },
  findByDocIdAndUserDeptRoleId(docId, userDeptRoleId) {
    let params = utils.merge({userDeptRoleId: userDeptRoleId});
    return httpService.get("/vbOutgoingDocUserView/findByDocIdAndUserDeptRoleId/" + docId, {params: params});
  },

  getLastSignedFile(docId) {
    return httpService.get("/vbOutgoingDocUserView/getLastSignedFile/" + docId);
  },
}



// WEBPACK FOOTER //
// ./src/services/vbOutgoingDocUserViewService.js